export default {
  typography: {
    fontFamily: "'SFT', 'Helvetica Neue','Helvetica','Arial', sans-serif",
  },
  palette: {
    type: 'light',
    primary: '#252525',
    primary1Color: '#252525',
  },
  appBar: {
    color: '#252525',
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 12,
      },
    },
  },
};

/*
sInput = {
  height: '50px'
},
sInputField = {
  marginTop: '6px'
},
sInputFloatingLabel = {
  top: '17px'
},
sInputFloatingLabelFocus = {
  top: '25px'
},
sInputHint = {
  bottom: '10px'
},
sInputUnderline = {
  bottom: '10px'
},
*/



// WEBPACK FOOTER //
// src/styles/theme.js